import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'highlightQuotes'
})
export class HighlightQuotesPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(value: string): SafeHtml {
    if (!value) return value;
    const transformedValue = value.replace(/"([^"]*)"/g, '<span style="color: green">"$1"</span>');
    return this.sanitizer.bypassSecurityTrustHtml(transformedValue);
  }
}